"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3298,7364],{

/***/ 43298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _utils_apiClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77364);



var autApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var res, featured, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    if (!localStorage.getItem("token")) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        _utils_apiClient__WEBPACK_IMPORTED_MODULE_0__/* .apiClient.get */ .x.get("/api/v1/auth/profile")
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        _utils_apiClient__WEBPACK_IMPORTED_MODULE_0__/* .apiClient.get */ .x.get("/api/v1/featured/mls")
                    ];
                case 2:
                    featured = _state.sent();
                    if (featured.ok) {
                        return [
                            2,
                            {
                                res: res,
                                featured: featured
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            res: res,
                            featured: null
                        }
                    ];
                case 3:
                    return [
                        2,
                        {
                            featured: null,
                            res: null
                        }
                    ];
                case 4:
                    error = _state.sent();
                    return [
                        2,
                        {
                            featured: null,
                            res: null
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function autApi() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (autApi);


/***/ }),

/***/ 77364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ apiClient; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50196);

var apiClient = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "https://api.bungalowfinder.ca"
});
// export const apiClient = axios.create({
//   baseURL: "http://127.0.0.1:2000",
// });
apiClient.interceptors.request.use(function(config) {
    var token = localStorage.getItem("token");
    if (!token) return config;
    if (config.headers) {
        config.headers["Authorization"] = "Bearer ".concat(token);
    }
    return config;
}, function(error) {
    return Promise.reject(error);
});
apiClient.interceptors.response.use(function(res) {
    var _res = {
        ok: true,
        data: res.data,
        status: res.status
    };
    return _res;
}, function(error) {
    var res = undefined;
    if (error.response) {
        var _message = [];
        _message.push(error.response.data.message);
        res = {
            status: error.response.status,
            error: "SERVER",
            message: _message,
            data: error.response.data,
            ok: false
        };
        if (res.status === 401) {
            localStorage.removeItem("token");
            window.dispatchEvent(new CustomEvent("unauth"));
        }
        return Promise.resolve(res);
    }
    if (error.request) {
        res = {
            status: 500,
            data: error.request,
            error: "CLIENT",
            message: error.message,
            ok: false
        };
        return Promise.resolve(res);
    }
    res = {
        status: 500,
        data: {},
        ok: false,
        error: "ANY",
        message: [
            "Internal Server Error"
        ]
    };
    return Promise.resolve(res);
});


/***/ })

}]);